// Action Types
export const FETCH_EVENTS_REQUEST = "FETCH_EVENTS_REQUEST";
export const FETCH_EVENTS_SUCCESS = "FETCH_EVENTS_SUCCESS";
export const FETCH_EVENTS_FAILURE = "FETCH_EVENTS_FAILURE";

// Action Creators
export const fetchEventsRequest = (params) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_EVENTS_REQUEST,
      payload: params,
    });
  };
};
export const fetchEventsSuccess = (data) => ({
  type: FETCH_EVENTS_SUCCESS,
  payload: data,
});
export const fetchEventsFailure = (error) => ({
  type: FETCH_EVENTS_FAILURE,
  payload: error,
});
